<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content content-with-nav pa-0"
    fluid
  >
    <!-- Hero section -->
    <page-hero title="Kernwoorden" />

    <!-- Content -->
    <v-row justify="center">
      <v-col
        class="center"
        cols="12"
        md="8"
        lg="6"
      >
        <p class="kernwoorden-info">
          Wat is typisch voor de overledene? Beschrijf hem/haar eens in een aantal kernwoorden.
        </p>
        <v-textarea
          v-model="kernwoorden.kernwoorden"
          auto-grow
          base-color="primary"
          bg-color="white"
          color="primary"
          density="compact"
          rows="4"
          variant="outlined"
        />
        <div class="d-flex justify-end">
          <v-btn
            color="primary"
            rounded
            @click="SaveKernwoorden"
          >
            <v-icon
              class="mr-1"
              size="18"
            >
              mdi-content-save-outline
            </v-icon>
            Opslaan
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <!-- Navigation -->
    <div class="samenstellen-nav">
      <div class="samenstellen-nav-inner">
        <v-btn
          v-if="samenstellenNavigation_PreviousItem"
          color="primary"
          :disabled="samenstellenNavigation_PreviousItem.disabled"
          rounded
          variant="text"
          @click="samenstellenNavigation_GoToPrevious"
        >
          <v-icon start>
            mdi-chevron-left
          </v-icon>
          {{ samenstellenNavigation_PreviousItem.title }}
        </v-btn>
        <span v-else />
        <v-btn
          v-if="samenstellenNavigation_NextItem"
          color="primary"
          :disabled="samenstellenNavigation_NextItem.disabled"
          rounded
          variant="text"
          @click="samenstellenNavigation_GoToNext"
        >
          {{ samenstellenNavigation_NextItem.title }}
          <v-icon end>
            mdi-chevron-right
          </v-icon>
        </v-btn>
        <span v-else />
      </div>
    </div>
  </v-container>
</template>

<script>
import PageHero from '@/components/PageHero.vue'
import authenticationMixin from '@/mixins/authenticationMixin'
import commonMixin from '@/mixins/commonMixin'
import errorMixin from '@/mixins/errorMixin'
import samenstellenNavigationMixin from '@/mixins/samenstellenNavigationMixin'
import klantService from '@/services/klantService'

export default {
  name: 'KernwoordenComponent',
  components: { PageHero },
  mixins: [
    authenticationMixin,
    commonMixin,
    errorMixin,
    samenstellenNavigationMixin
  ],
  data () {
    return {
      kernwoorden: {}
    }
  },
  mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    this.$store.state.headers.samenstellen = true
    klantService.Init(this)
    this.GetKernwoorden()
  },
  beforeUnmount () {
    this.$store.state.headers.samenstellen = false
  },
  methods: {
    async GetKernwoorden () {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetUitvaartDraaiboekKernwoorden()

      if (resp && (resp.data || resp.data !== '')) {
        this.kernwoorden = resp.data
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    async SaveKernwoorden () {
      this.CommonMixin_Load(this.$options.name, true)
      await klantService.SaveUitvaartDraaiboekKernwoorden(this.kernwoorden)
      this.CommonMixin_Load(this.$options.name, false)
    }
  }
}
</script>

<style scoped>
.kernwoorden-info {
  font-size: 15px;
  color: #424E58;
  padding: 0;
  margin: 0 0 4px 0;
}
</style>
